import _ from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import ModalPopUp from "@/Components/common/ModalPopUp";
import { RejectIcon } from "@/Components/Icons/RejectIcon";
import { toggleTimesheetMoreInfoModal } from "@/reducers/timesheets/timesheetterminated";
import { getWorkedStatusClasses } from "@/utilities/utils";

import { routingConstants } from "../../../Constants/routingConstants";
const TimesheetMoreInfoModal = () => {
  const dispatch = useDispatch();
  const { showTimesheetMoreInfoModal, viewMoreInfo } = useSelector(
    (state) => state.clientTimesheetTerminated,
  );
  return (
    <ModalPopUp
      show={showTimesheetMoreInfoModal && !_.isEmpty(viewMoreInfo)}
      panelClass="max-w-[770px]"
    >
      <div className="flex flex-col gap-4">
        <div className="flex justify-between">
          <h3 className="text-[20px] font-semibold leading-[normal] text-black">
            More Info
          </h3>
          <button
            onClick={() => {
              dispatch(toggleTimesheetMoreInfoModal(false));
            }}
            className="text-red outline-none ring-0"
          >
            <RejectIcon />
          </button>
        </div>
        <div>
          {/* reason,
                terminated_by,
                user_department,
                user_type,
                status, */}
          <div className="grid gap-3">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
              <div>
                <span className="text-[14px]">Terminated by</span>
              </div>
              <div className="col-span-2">
                <span className="text-[14px] font-medium capitalize text-txtDark">
                  {viewMoreInfo.user_type === "candidate"
                    ? viewMoreInfo?.terminated_candidate_name
                    : viewMoreInfo?.terminated_by}{" "}
                  &nbsp;
                  {viewMoreInfo.user_type ? `[${viewMoreInfo.user_type}]` : "-"}
                </span>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
              <div>
                <span className="text-[14px]">User Department</span>
              </div>
              <div className="col-span-2">
                <span className="text-[14px] font-medium text-txtDark">
                  {viewMoreInfo.user_department
                    ? viewMoreInfo.user_department
                    : "-"}
                </span>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
              <div>
                <span className="text-[14px]">Timesheet Status</span>
              </div>

              <div className="col-span-2">
                <div
                  className={`inline-block rounded-md px-2 py-1 font-medium ${getWorkedStatusClasses(viewMoreInfo.status)}`}
                >
                  {viewMoreInfo.status}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
              <div>
                <span className="text-[14px]">Reason</span>
              </div>
              <div className="col-span-2">
                <span className="text-[14px] font-medium text-txtDark">
                  {viewMoreInfo.reason ? viewMoreInfo.reason : "-"}
                </span>
              </div>
            </div>

            {viewMoreInfo?.is_proposed_timesheet ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
                <div>
                  <span className="text-[14px]">Cover By</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-[14px] font-medium !text-primary">
                    <Link
                      to={routingConstants.contractDetail(
                        viewMoreInfo.cover_by_contract_id,
                      )}
                      className="truncate text-[14px] font-semibold leading-[normal] text-primary"
                    >
                      {viewMoreInfo.cover_by_contract_ref}
                    </Link>
                  </span>
                  <span className="text-[14px] font-medium !text-primary">
                    <Link
                      to={routingConstants.candidateDetail(
                        viewMoreInfo.cover_by_candidate_id,
                      )}
                      className="truncate text-[14px] font-semibold leading-[normal] text-primary"
                    >
                      {viewMoreInfo.cover_by_candidate_name}
                      {/* {viewMoreInfo.cover_by_contract_ref} */}
                    </Link>
                  </span>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </ModalPopUp>
  );
};

export default TimesheetMoreInfoModal;
